module.exports = __webpack_public_path__ + "static/img/guideDeepBg.f4854c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/guideDeepBg.png
// module id = lgU7
// module chunks = 0